var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.to ? 'router-link' : 'div',{tag:"component",staticClass:"jdsc-badge",class:( _obj = {}, _obj[_vm.color] = true, _obj['link'] =  _vm.to, _obj ),attrs:{"to":_vm.to}},[(_vm.icon)?_c('jds-icon',{attrs:{"inline":""}},[_c('jds-glyph',{attrs:{"for":_vm.icon}})],1):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }